export const size = {
  mobileEnds: '767.98px',
  tabletStarts: '768px',
  tabletEnds: '1023.98px',
  desktopStarts: '1024px'
}
const device = {
  min: {
    // mobile: `(min-width: ${size.mobile})`,
    tablet: `(min-width: ${size.tabletStarts})`,
    desktop: `(min-width: ${size.desktopStarts})`
  },
  max: {
    mobile: `(max-width: ${size.mobileEnds})`,
    tablet: `(max-width: ${size.tabletEnds})`,
    desktop: `(max-width: ${size.desktopStarts})`
  },
};

export default device